"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedFunction = void 0;
var react_1 = __importDefault(require("react"));
/**
 * @param {Function} func
 * @param {number} delay
 * @param {boolean} cleanUp
 * https://habr.com/ru/company/domclick/blog/510616/
 */
function useDebouncedFunction(func, delay, cleanUp) {
    var timeoutRef = react_1.default.useRef();
    /**
     * Очистка таймера
     */
    function clearTimer() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }
    }
    /**
     * Очищаем таймер при анмаунте компонента, если cleanUp выставлен в true
     * и тем самым отменяем последний запланированный вызов
     */
    react_1.default.useEffect(function () { return (cleanUp ? clearTimer : undefined); }, [cleanUp]);
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimer();
        timeoutRef.current = setTimeout(function () { return func.apply(void 0, args); }, delay);
    };
}
exports.useDebouncedFunction = useDebouncedFunction;
//# sourceMappingURL=useDebouncedFunction.js.map